/* Dot pagination for the product media gallery slider. */
(function () {
  function init(gallery) {
    var slider = gallery.querySelector('slider-component');
    if (!slider || slider.dataset.dotsReady) return;
    var list = slider.querySelector('ul[id^="Slider-Gallery"]');
    if (!list) return;
    var slides = Array.prototype.filter.call(list.children, function (li) {
      return !li.classList.contains('hidden');
    });
    if (slides.length < 2) return;
    slider.dataset.dotsReady = 'true';

    var dots = document.createElement('div');
    dots.className = 'gallery-dots';
    slides.forEach(function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gallery-dots__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Go to image ' + (i + 1));
      b.addEventListener('click', function () {
        list.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });
    slider.appendChild(dots);

    function sync() {
      var i = Math.round(list.scrollLeft / Math.max(1, slides[1].offsetLeft - slides[0].offsetLeft));
      Array.prototype.forEach.call(dots.children, function (d, k) {
        d.classList.toggle('is-active', k === Math.min(i, slides.length - 1));
      });
    }
    list.addEventListener('scroll', function () { window.requestAnimationFrame(sync); });
  }

  function boot() {
    document.querySelectorAll('media-gallery').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
